import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as Agency from "../modules/agency";
import {AgencyModuleStoreInterface} from "../types";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const AgencyRouter = ({ isAuthenticated, agencyStore }: {
    isAuthenticated: () => boolean,
    agencyStore:  AgencyModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/agency",
                element: <Agency.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/agency/:id/edit",
                element: <Agency.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return agencyStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/agency/add",
                element: <Agency.Add />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return agencyStore.prepareAddForm();
                },
            },
            {
                path: "/agency/:id/view",
                element: <Agency.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return agencyStore.view({ id: params.id });
                },
            },
            {
                path: "/agency/:id/view_history",
                element: <Agency.ViewHistory />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return agencyStore.viewHistory({ id: params.id });
                },
            },
        ]
    }
)